import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchUserPermissions, UserPermissionDTO } from './UserApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const UserPermissionList: React.FC = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState<UserPermissionDTO[]>([]);
  const [loading, setLoading] = useState(false);

  const loadPermissions = async () => {
    if (!userId) return;
    try {
      setLoading(true);
      const response = await fetchUserPermissions(userId);
      setPermissions(response.data);
    } catch (error) {
      console.error('Failed to fetch user permissions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPermissions();
  }, [userId]);

  const renderBackButton = () => (
    <button
      onClick={() => navigate('/admin/users')}
      className="mb-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 flex items-center gap-2"
    >
      <FontAwesomeIcon icon={faArrowLeft} />
      Back
    </button>
  );

  return (
    <div className="p-6">
      {/* Back Button - Top */}
      {renderBackButton()}

      <h2 className="text-xl font-semibold mb-4">User Permissions</h2>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <table className="min-w-full table-auto border text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2">Module</th>
              <th className="border px-3 py-2">Description</th>
              <th className="border px-3 py-2">Create</th>
              <th className="border px-3 py-2">View</th>
              <th className="border px-3 py-2">Edit</th>
              <th className="border px-3 py-2">Delete</th>
              <th className="border px-3 py-2">Report</th>
            </tr>
          </thead>
          <tbody>
            {permissions.map((perm) => (
              <tr key={perm.moduleId} className="hover:bg-gray-50">
                <td className="border px-3 py-2">{perm.moduleName}</td>
                <td className="border px-3 py-2">{perm.moduleDescription}</td>
                <td className="border px-3 py-2 text-center">{perm.canCreate ? '✅' : '❌'}</td>
                <td className="border px-3 py-2 text-center">{perm.canView ? '✅' : '❌'}</td>
                <td className="border px-3 py-2 text-center">{perm.canEdit ? '✅' : '❌'}</td>
                <td className="border px-3 py-2 text-center">{perm.canDelete ? '✅' : '❌'}</td>
                <td className="border px-3 py-2 text-center">{perm.canReport ? '✅' : '❌'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Back Button - Bottom */}
      <div className="mt-6">{renderBackButton()}</div>
    </div>
  );
};

export default UserPermissionList;